import content from './content/about.json';

export const aboutMock = {
  name: 'about',
  layoutType: 1,
  areasList: [
    {
      id: 'about-main',
      componentName: 'Comp:AboutPage',
      content: JSON.stringify(content)
    }
  ]
};
